export default {
  adminDashboard: 'admin',
  customerBuilds: 'customer-builds',
  organizationCreate: 'organization/create',
  organizationDetails: 'organization/:organizationId',
  organizations: 'organizations',
  objectRestoreCreate: 'object-restore-request/create',
  objectRestoreRequest: 'object-restore-request/:jobId',
  groups: 'groups',
  groupCreate: 'group/create',
  groupDetails: 'group/:groupId',
  dataFeeds: 'data-feeds',
  dataFeedDetails: 'data-feed/:dataFeedId',
  slaTaskDetails: 'sla/:slaTaskId',
  licenses: 'licenses',
  tasks: 'tasks',
  userDetails: 'user/:userId',
  users: 'users',
  userCreate: 'user/create',
  emails: 'emails',
  reports: 'reports',
  workbench: 'workbench',
};
